import { useQuery } from "@tanstack/react-query";

import type { GlobalFilters } from "../../lib/globalFilters";
import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

export const ANALYTICS_QUERY_KEY = ["analytics"] as const;

export type AnalyticsFilters = Pick<
  GlobalFilters,
  "since" | "until" | "account_id" | "tag_id"
>;

export function toAnalyticsQuery(filters: AnalyticsFilters) {
  return {
    since: filters.since,
    until: filters.until,
    account_id: filters.account_id ? [filters.account_id] : undefined,
    tag_id: filters.tag_id,
  };
}

// Shared query definition reused by the hook and by nav prefetch.
export function summaryQueryOptions(client: ApiClient, filters: AnalyticsFilters = {}) {
  return {
    queryKey: [...ANALYTICS_QUERY_KEY, "summary", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/summary", {
        params: { query: toAnalyticsQuery(filters) },
      });
      if (error !== undefined) {
        throw new Error("Failed to load performance summary");
      }
      return data;
    },
  };
}

export function useSummary(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery(summaryQueryOptions(client, filters));
}
